import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { useAuth } from "./context/auth-context";
import { useWorkspaces, getWorkspaces } from "./queries";
import { useCurrentUser } from "./queries/users";
import {
  getInitialActiveWorkspaceId,
  getUserDefaultWorkspaceId,
  resolveActiveWorkspaceId,
} from "./utils/activeWorkspace";

const RedirectContent = ({
  isLoading,
  hasWorkspaces,
  targetWorkspaceId,
  isAuthenticated,
}: {
  isLoading: boolean;
  hasWorkspaces: boolean;
  targetWorkspaceId: number;
  isAuthenticated: boolean;
}) => {
  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!hasWorkspaces) {
    return <Navigate to="/onboarding" />;
  }

  if (targetWorkspaceId) {
    return <Navigate to={`/workspace/${targetWorkspaceId}/home`} />;
  }

  return <Navigate to="/login" />;
};

export const ChooseWorkspaceAndRedirect = () => {
  const auth = useAuth();
  const activeWorkspaceId = getInitialActiveWorkspaceId();
  const workspacesQuery = useWorkspaces();
  const { data: currentUser, isLoading: isCurrentUserLoading } = useCurrentUser();

  // TODO: remove when BE is ready
  const fallbackWorkspacesQuery = useQuery(["fallback_workspaces", auth?.userToken], () =>
    getWorkspaces(auth?.userToken ?? ""),
  );

  const workspaces = workspacesQuery.data?.workspaces || fallbackWorkspacesQuery.data?.workspaces;
  const targetWorkspaceId = resolveActiveWorkspaceId({
    workspaces: workspaces ?? [],
    storedWorkspaceId: activeWorkspaceId,
    defaultWorkspaceId: getUserDefaultWorkspaceId(currentUser),
  });

  return (
    <RedirectContent
      isLoading={
        workspacesQuery.isLoading || isCurrentUserLoading || fallbackWorkspacesQuery.isLoading
      }
      hasWorkspaces={(workspaces && workspaces?.length > 0) ?? false}
      targetWorkspaceId={targetWorkspaceId ?? 0}
      isAuthenticated={!!auth?.userToken}
    />
  );
};
